import { QDataRefreshRFC } from "./QDataRefreshRFC";
import { ThrowHTMLStatusAlert } from "../utils/ThrowHTMLStatusAlert";
import { Globals } from "./Globals";

export class QReloadMasterChartFieldsRFC extends QDataRefreshRFC {
  constructor() {
    super();
  }

  DoTransactionComplete(response) {
    Globals._wsMgr.EndProgress();
    var jsonResponse = JSON.parse(response);

    if (jsonResponse["success"]) {
      var status = "success";
      message = "Fields successfully loaded into open Background";

      var doc = Globals._wsMgr.GetDoc();
      doc.SyncChartFieldsToDoc(jsonResponse["data"]);
      Globals._wsMgr.SetDirty();
    } else {
      var message = "There was an issue importing fields'. Please try again.";
      status = "error";
    }

    ThrowHTMLStatusAlert(status, message);

    Globals._wsMgr.PrepRenderWS();
    Globals._wsMgr.RenderWS();
  }
}
